import React from 'react';

import HeaderLoader from './HeaderLoader';
import HeaderLogo from './HeaderLogo';
import HeaderNav from './HeaderNav';
import NavigationMenu from './NavigationMenu';
import LoginWizard from '../../LoginWizard/components/LoginWizard';

import styles from './Header.module.scss';

const Header = ({ sharedAssetsPaths }) => {
  return (
    <>
      <HeaderLoader />
      <header className={styles.header}>
        <HeaderLogo logoImageSrc={sharedAssetsPaths?.isibuteLogo} />
        <HeaderNav />
      </header>
      <div className={styles.headerSpacer}></div>
      <NavigationMenu />
      <LoginWizard />
    </>
  );
};

export default Header;
